<div class="issue2018-container">
  <!-- HEADER -->
  @if (isExistingHeaderVisible) {
    <div
      class="issue2018-header issueTableHeaderCommon"
      [style.grid-template-columns]="gridTemplateHeader"
    >
      @for (column of displayColumns; track column.key) {
        <div
          class="header2018-cell headerCellText"
          [ngClass]="column.lines?.length ? 'customFlex' : ''"
        >
          @if (column.lines?.length) {
            @for (line of column.lines; track $index) {
              <h2>{{ line }}</h2>
            }
          } @else {
            <h2>{{ column.label }}</h2>
          }
        </div>
      }
    </div>
  }

  @for (record of records; track record.id) {
    <div
      class="info2018-records"
      [ngClass]="{
        gridInfoColumn: mode === 'allIssues',
      }"
    >
      <div
        class="records-container"
        [ngClass]="{
          'cancel-record': record.isCancelled,
        }"
      >
        @for (row of record.rows; track row.empty) {
          <div
            class="first-column"
            [style.grid-template-columns]="gridTemplate"
            [ngClass]="action === 'edit' ? 'Custom2018TableBG' : ''"
          >
            @for (column of displayColumns; track column.key) {
              @if (column.key === 'issueInfo') {
                <div class="cellValue">
                  <p>{{ row.issueInfo }}</p>
                </div>
              } @else if (column.key === 'empty') {
                <h2 class="row-heading">
                  {{ row.empty }}
                </h2>
              } @else {
                <div class="cellValue">
                  @if (action === 'view') {
                    @if (column.key === 'saa' && row.saaLabel) {
                      <div
                        class="d-Flex"
                        [ngClass]="row.saaLabel === 'LINK' ? 'customInputWidth' : ''"
                      >
                        @if (row.saaLabel === 'LINK') {
                          @let spDocLink = getSpDocLink(row.saa);
                          @if (spDocLink.isClickable) {
                            <p
                              class="linkBTN"
                              id="link"
                              role="link"
                              tabindex="0"
                              [title]="spDocLink.title"
                              (click)="navigateToLink(row.saa ?? '')"
                              (keydown)="onLinkKeydown($event, row.saa ?? '')"
                            >
                              {{ spDocLink.displayText }}
                            </p>
                          } @else if (spDocLink.displayText) {
                            <p
                              class="linkBTN"
                              id="link"
                              [title]="spDocLink.title"
                              style="cursor: default"
                            >
                              {{ spDocLink.displayText }}
                            </p>
                          }
                        } @else {
                          <div class="d-Flex linkBTN" id="NPARow">
                            <h2 id="npaHeading">{{ row.saaLabel }}</h2>
                            <p class="pl-5 linkBTN" [title]="row.saa">
                              {{ row.saa }}
                            </p>
                          </div>
                        }
                      </div>
                    } @else {
                      <p>{{ getCellValue(row, column.key) }}</p>
                    }
                  } @else if (action === 'edit') {
                    @if (
                      row.empty === 'TI b/f 199' ||
                      (row.empty === '199 Deduct' &&
                        ['us', 'general', 'fogei', 'fori', 'passive'].includes(column.key)) ||
                      (row.empty === 'FTC' &&
                        ['general', 'fogei', 'fori', 'passive'].includes(column.key)) ||
                      (row.empty === 'GBC' && column.key === 'us')
                    ) {
                      <input
                        type="text"
                        [ngModel]="getCellValue(row, column.key)"
                        (ngModelChange)="updateCell(row, column.key, $event)"
                        (keydown)="allowNumericDecimal($event, getCellValue(row, column.key))"
                        (paste)="handleIntegerPaste($event, row, column.key)"
                        (drop)="handleIntegerDrop($event, row, column.key)"
                      />
                    }
                  }
                </div>
              }
            }
          </div>
        }

        <!-- Footer-Row (5th) Constant -->
        @if (showAdditionalColumns) {
          <div class="footer-row" [style.grid-template-columns]="gridTemplate">
            <div>{{ record.cfc ?? '' }}</div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div class="d-Flex justify-content-center" style="white-space: nowrap">
              <h2>NPA ties AR/SAA</h2>
            </div>
            <div>{{ record.isNPATied }}</div>
            <div class="d-Flex gap-2 justify-content-center">
              @if (record.deduction199) {
                <div class="image-checkbox-checked" [class.checked]="true">✓</div>
              } @else {
                <div class="image-checkbox-unchecked" [class.checked]="false"></div>
              }
              <h2>199</h2>
            </div>
            <div class="d-Flex gap-2 justify-content-center">
              @if (record.asC_740Flag) {
                <div class="image-checkbox-checked" [class.checked]="true">✓</div>
              } @else {
                <div class="image-checkbox-unchecked" [class.checked]="false"></div>
              }
              <h2>ASC 740</h2>
            </div>
            <div></div>
          </div>
        }
      </div>

      <!-- ICONS -->
      @if (showAdditionalColumns) {
        <div class="actionColumn custom-icons gap-2">
          <!-- Audit Trail Records -->
          <button
            type="button"
            class="btn btn-link p-0 successIcon iconCSS"
            (click)="showAudit(record)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 24 24"
              stroke-width="1.75"
            >
              <title>Audit Trail Records</title>
              <path d="M4 3h11l5 5v13H4z" fill="#f8f8f8" stroke="#0b2d71" />
              <circle cx="8" cy="10" r="1.2" fill="#0b2d71" />
              <circle cx="8" cy="14" r="1.2" fill="#0b2d71" />
              <circle cx="8" cy="18" r="1.2" fill="#0b2d71" />
              <line x1="8" y1="10" x2="8" y2="18" stroke="#0b2d71" />
              <line x1="11" y1="10" x2="17" y2="10" stroke="#0b2d71" />
              <line x1="11" y1="14" x2="17" y2="14" stroke="#0b2d71" />
              <line x1="11" y1="18" x2="15" y2="18" stroke="#0b2d71" />
            </svg>
          </button>

          @if (showHideIcons) {
            <!-- Edit -->
            <button
              type="button"
              class="btn btn-link p-0 successIcon iconCSS"
              (click)="editRecord(record)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="21"
                height="21"
                fill="none"
                stroke="#0b2d71"
                stroke-width="2.2"
              >
                <title>Edit Record</title>
                <path
                  d="M3 17.25V21h3.75L17.8 9.94l-3.75-3.75L3 17.25zm17.71-10.04a1.003 1.003 0 0 0 0-1.42l-2.5-2.5a1.003 1.003 0 0 0-1.42 0l-1.96 1.96 3.75 3.75 2.13-1.79z"
                />
              </svg>
            </button>

            <!-- Delete -->
            <button
              type="button"
              class="btn btn-link p-0 dangerIcon iconCSS"
              (click)="deleteRecord(record)"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="rotate: -5deg"
              >
                <title>Cancel Record</title>
                <path
                  d="M6 6L18 18M18 6L6 18"
                  stroke="#0F3D8F"
                  stroke-width="2.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          }
        </div>
      }
    </div>
  }
</div>
